<template>
  <v-card>
    <v-card-title>
      <v-spacer />
      <v-text-field
        v-model="pesquisar"
        append-icon="search"
        label="Pesquisar"
        single-line
        hide-details
      />
      <v-spacer />
    </v-card-title>
    <v-card-text class="pa-0">
      <v-data-table
        :headers="headers_organizacao"
        :items="habilitacaoOrganizacoes"
        :pagination.sync="pagination_organizacao"
        :total-items="totalItems"
        :loading="!habilitacaoOrganizacoes.length"
        :search="pesquisar"
        item-key="co_organizacao"
        class="elevation-1"
      >
        <template
          slot="items"
          slot-scope="props"
        >
          <td>{{ props.item.cnpj_formatado }}</td>
          <td>{{ props.item.no_organizacao }}</td>
          <td>
            <v-chip
              dark
              color="primary"
            >
              {{ props.item.segmento.ds_detalhamento }}
            </v-chip>
          </td>
          <td>{{ props.item.pontuacao_inicial }}</td>
          <td>{{ props.item.pontuacao_habilitacao }}</td>

          <td class="text-md-center">
            <v-chip dark :color="obterSituacaoAvaliacao(props.item.st_habilitacao).color">{{ obterSituacaoAvaliacao(props.item.st_habilitacao).text }}</v-chip>
          </td>
          
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'OrganizacaoLista',
  props: {
    souAdministrador: {
      source: {
        type: Boolean,
        default: false,
      },
    },
  },
  data: () => ({
    pesquisar: '',
    tipoModal: '',
    pagination_organizacao: {
      page: 1,
      rowsPerPage: 10,
      sortBy: 'no_organizacao',
      descending: false,
    },
    totalItems: 0,
    headers_organizacao: [
      {
        text: 'CNPJ',
        value: 'cnpj_formatado',
      },
      {
        text: 'Nome da Organização ou Entidade',
        value: 'no_organizacao',
      },
      {
        text: 'Segmento',
        value: 'segmento.ds_detalhamento',
      },
      {
        text: 'Pontuação Inicial',
        value: 'pontuacao_inicial',
      },
      {
        text: 'Pontuação Final',
        value: 'pontuacao_final',
      },
      {
        text: 'Habilitação',
        value: 'st_habilitacao',
      },
    ],
  }),
  computed: {
    ...mapGetters({
      habilitacaoOrganizacoes: 'organizacao/habilitacaoOrganizacoes',
      usuarioPerfil: 'conta/perfil',
      ativarListaFinalHabilitados: 'fase/ativarListaFinalHabilitados',
    }),
  },
  methods: {
    ...mapActions({
      obterListaHabilitacao: 'organizacao/obterListaParcialHabilitacao',
    }),
    gerarRelatorioExcelListaInscritos(){
      this.gerarRelatorioExcelListaInscritosAction();
    },
    obterSituacaoAvaliacao(stHabilitacao) {
      let parecer = {};
      switch (parseInt(stHabilitacao)) {
        case 0:
          parecer = {
            text: 'Inabilitada',
            color: "error"
          };
          break;
        case 1:
          parecer = {
            text: 'Habilitada e desclassificada',
            color: 'warning'
          };
          break;
        case 2:
          parecer = {
            text: 'Habilitada e classificada',
            color: 'success'
          };
          break;
        case 3:
          parecer = {
            text: 'Habilitada',
            color: 'success'
          };
          break;
        default:
          parecer = { text: 'Pendente' , color: 'warning' };
          break;
      }

      return parecer;
    },
  },
  mounted() {
    this.obterListaHabilitacao();
  },
};
</script>
